import { toast } from "@/components/ui/use-toast";

export function copyToClipboard(value: string, successMessage?: string) {
  navigator.clipboard
    .writeText(value)
    .then(() => {
      toast({
        title: successMessage || "Copiado!",
        description: "O código foi copiado para a área de transferência.",
      });
    })
    .catch(() => {
      toast({
        title: "Erro ao copiar",
        description: "Não foi possível copiar para a área de transferência.",
        variant: "destructive",
      });
    });
}
